import { HeartFilledIcon, HeartIcon } from '@radix-ui/react-icons';
import { type MouseEventHandler } from 'react';

import { Button, type ButtonProps } from '../ui/button';

export function FavoriteButton({
  highlighted,
  type = 'button',
  size = 'default',
  onClick,
}: {
  highlighted: boolean;
  type?: 'button' | 'submit';
  size?: ButtonProps['size'];
  onClick?: MouseEventHandler<HTMLButtonElement>;
}) {
  return (
    <Button
      type={type}
      name="favorite"
      variant="ghost"
      size={size}
      className="hover:bg-unset"
      onClick={onClick}
    >
      {highlighted ? (
        <HeartFilledIcon className="size-full text-destructive hover:text-destructive-dark" />
      ) : (
        <HeartIcon className="size-full text-primary hover:text-secondary" />
      )}
    </Button>
  );
}
